export default "__VITE_ASSET__CZxaoS2y__"